import { dispatchTrackingEvent } from '@context/tracking/utils';
import { isDesktop } from '@utils/helpers';

type FiltrationAction =
  | 'filtration_used'
  | 'filtration_removed'
  | 'filtration_opened'
  | 'filtration_closed'
  | 'filtration_drawer_opened'
  | 'filtration_drawer_closed'
  | 'filtration_dropdown_opened'
  | 'filtration_dropdown_closed'
  | 'filtration_confirmed'
  | 'filtration_filter_removed'
  | 'filtration_quick_used';

export const trackFiltration = ({
  timing,
  name,
  interaction,
  action,
  filters = undefined,
  type = undefined,
}: {
  timing: number;
  name: string;
  interaction: string;
  action: FiltrationAction;
  filters?: string;
  type?: string;
}) => {
  const filtration = {
    interaction,
    action,
    variant: isDesktop() ? ('desktop' as const) : ('mobile' as const),
    name,
    timing,
    ...(type !== undefined && { type }),
    ...(filters !== undefined && { filters }),
  };

  dispatchTrackingEvent(
    // Cast needed: the tracking library expects a discriminated union on `action`,
    // but this helper builds the object dynamically with optional spread properties
    {
      event: 'filtration_click',
      filtration,
      _clear: true,
    } as unknown as Parameters<typeof dispatchTrackingEvent>[0]
  );
};
